import {
  PROVIDER_PANDAPAY,
  CURRENCY_CAD,
  STATUS_PENDING,
} from "@/constants/elixioPayTransactions.js";
export default {
  type: "elixiopay-transactions",
  provider: PROVIDER_PANDAPAY,
  provider_transaction_id: null,
  organization_id: null,
  third_party_service_id: null,
  payable_type: null,
  payable_id: null,
  amount: 0,
  currency: CURRENCY_CAD,
  payment_method: null, // CB ou TFE
  status: STATUS_PENDING,
  metadata: {},
  error_message: null,
  relationshipNames: ["organization", "thirdPartyService", "payable"],
};
